import React from 'react'

function ServiceDetailsItems() {
  return (
    <>
      <div className="service-items sec-mar-top">
        <div className="service-details-item">
          <div className="row">
            <div className="col-lg-6">
              <div className="single-details">
                <h4><span>01</span>Brainstroming &amp; Wirefarme</h4>
                <p>Interdum et malesuada fames ac ante ipsum primis in faucibus. Etiam eu nibh elementum, accumsan ona vestibulum ultricies tellus. volv Pellentesque vel tu neque ac, aliquet nunc. In eu ipsum fringilla, accumsan purus vel, tourbakaniv pellentesque risus. Vivamus vehicula nl hendrerit vel tortor. In pharetra lectus purus at eros interdum, in dignissim nulla vestibulum. Nunc sit amet finibuson felis, ut egestas lacus. Sedan pellentesque quis magna eu vestibulum. Olangb pellentesque quis magna eu vestibulum. Ut sed commodo neque. Morbi erat nisi, vehicula quis faucibus il</p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="single-details-thumb">
                <img src={process.env.PUBLIC_URL + '/img/blog/thumb-1.jpg'} alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="service-details-item">
          <div className="row">
            <div className="col-lg-6 or-2">
              <div className="single-details-thumb">
                <img src={process.env.PUBLIC_URL + '/img/blog/thumb-2.jpg'} alt="" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="single-details">
                <h4><span>02</span>UI Design</h4>
                <p>Interdum et malesuada fames ac ante ipsum primis in faucibus. Etiam eu nibh elementum, accumsan ona vestibulum ultricies tellus. volv Pellentesque vel tu neque ac, aliquet nunc. In eu ipsum fringilla, accumsan purus vel, tourbakaniv pellentesque risus. Vivamus vehicula nl hendrerit vel tortor. In pharetra lectus purus at eros interdum, in dignissim nulla vestibulum. Nunc sit amet finibuson felis, ut egestas lacus. Sedan pellentesque quis magna eu vestibulum. Olangb pellentesque quis magna eu vestibulum. Ut sed commodo neque. Morbi erat nisi, vehicula quis faucibus il</p>
              </div>
            </div>
          </div>
        </div>
        <div className="service-details-item">
          <div className="row">
            <div className="col-lg-6">
              <div className="single-details">
                <h4><span>03</span>Final Developing</h4>
                <p>Interdum et malesuada fames ac ante ipsum primis in faucibus. Etiam eu nibh elementum, accumsan ona vestibulum ultricies tellus. volv Pellentesque vel tu neque ac, aliquet nunc. In eu ipsum fringilla, accumsan purus vel, tourbakaniv pellentesque risus. Vivamus vehicula nl hendrerit vel tortor. In pharetra lectus purus at eros interdum, in dignissim nulla vestibulum. Nunc sit amet finibuson felis, ut egestas lacus. Sedan pellentesque quis magna eu vestibulum. Olangb pellentesque quis magna eu vestibulum. Ut sed commodo neque. Morbi erat nisi, vehicula quis faucibus il</p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="single-details-thumb">
                <img src={process.env.PUBLIC_URL + '/img/blog/thumb-3.jpg'} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>   
    </>
  )
}

export default ServiceDetailsItems